import { all, } from 'redux-saga/effects'

import accountSagas from './account'
import userManagementSagas from './userManagement'
import notificationSagas from './notification'
import controlRoomRequestingSagas from './controlRoomRequesting'

export default function* rootSaga() {
  yield all([
    ... accountSagas,
    ... userManagementSagas,
    ... notificationSagas,
    ... controlRoomRequestingSagas,
  ])
}
